'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { changeFilters } from 'AdsUI/actions/GlobalFilterActions';
import StatusFilter from 'AdsUI/components/StatusFilter';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';

const GlobalCampaignStatusFilterContainer = (_ref) => {
  let {
    globalFilters: {
      statuses: campaignStatuses
    }
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["globalFilters"]);

  return /*#__PURE__*/_jsx(StatusFilter, {
    statuses: campaignStatuses,
    onChangeStatuses: statuses => props.changeFilters({
      statuses
    })
  });
};

function select(state) {
  return {
    globalFilters: getGlobalFilters(state)
  };
}

const mapDispatchToProps = {
  changeFilters
};
export default connect(select, mapDispatchToProps)(GlobalCampaignStatusFilterContainer);